"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _H = require("./H1");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var H4 = /*#__PURE__*/
(0, _reactEmotion.default)('h4', {
  target: "e11w2n9o0"
})(_base.default, ";", _font.default, ";", _H.text, ";font-size:", function (props) {
  return props.fontSize || '1.25rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '2rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 300;
}, ";text-align:", function (props) {
  return props.center ? 'center' : 'inherit';
}, ";", (0, _mediaQueries.default)('md'), "{font-size:0.875rem;line-height:1.5rem;}");
var _default = H4;
exports.default = _default;